<script setup lang="ts">
import { computed, defineProps } from 'vue'
import { useI18n } from 'vue-i18n'

import { BlockContainer, ListOfSources } from '@toni/brand-ui'

import { usePageStore } from '../../stores/page'
import { usePageBlockWidth } from '../../composables/use-page-block-width.ts'
import { useContentBlock } from '../../content-blocks/composables/use-content-block'

const props = defineProps<{ id: string }>()

const id = computed(() => props.id)
const contentBlock = useContentBlock(id.value, 'listOfSources')

const { t } = useI18n()

const headline = computed(() => contentBlock.value?.data?.listOfSources?.title || t('listOfSources.headline'))
const showLabel = t('listOfSources.show')
const hideLabel = t('listOfSources.hide')

const pageStore = usePageStore()
const brand = computed(() => pageStore.brandFromStore as string)
const isHome = computed(() => pageStore.isHome as boolean)
const size = computed(() => usePageBlockWidth(pageStore.pageData?.pageMeta, isHome.value, brand.value).value)

</script>

<template>
  <BlockContainer :size="size"
                  class="flex justify-center md:justify-start w-[320px] md:w-[764px]">
    <ListOfSources
      :value="contentBlock.data.listOfSources"
      :headline="headline"
      :show-label="showLabel"
      :hide-label="hideLabel" />
  </BlockContainer>
</template>
